<utc-modal class='hvac-address-lookup-modal' size="dynamic-height" (closeAction)="onCancel()"
    [visible]="visible" theme='rounded' [showHeader]="false">
    <ng-container *ngIf="address$ | async as addressSet">
        <div class="hvac-address-lookup-wrapper">
            <h3 class="hvac-h3">{{
                'ADDRESS_LOOKUP.ADDRESS_SUGGESTION' | translate }}</h3>
            <div class="hvac-divider hvac-button-divider"></div>
            <div class="hvac-address-lookup-input" *ngIf="addressLookup">
                <p class="hvac-label hvac-address-lookup-title">
                    {{ 'ADDRESS_LOOKUP.SEARCH_FOR' | translate }}</p>
                <p class="hvac-info-value hvac-company-address-information hvac-label">
                    <hvac-address [name]="addressLookup.address1" [line2]="addressLookup.address2"
                    [city]="addressLookup.city" [state]="addressLookup.state.code"
                    [country]="addressLookup.country.code" [zipCode]="addressLookup.postalCode"></hvac-address>
                </p>
            </div>
            <div class="hvac-address-lookup-export-warning" *ngIf="!(processStatus$ | async) && !isLoading">
                <hvac-toast [name]="toastOutlet"></hvac-toast>
            </div>
            <div class="hvac-address-lookup-table">
                <hvac-table>
                    <thead>
                        <tr>
                            <td *ngFor="let item of dataHeaders">
                                <button class="hvac-table-sort-btn">
                                    <span class="hvac-address-lookup-column-header">{{item.title}}</span>
                                    <span class="hvac-table-list-sort" [ngClass]="{
                                        'hvac-table-list-sort-show': item.order,
                                        'column-ascending': item.order === 'asc'
                                    }">
                                        <utc-svg src="assets/icons/chevron-down.svg"></utc-svg>
                                    </span>
                                </button>
                            </td>
                        </tr>
                    </thead>
                    <tbody *ngIf="!isLoading; else loading">
                        <tr *ngFor="let address of addressSet; let indexOfElement = index;" [ngClass]="{'hvac-address-lookup-form-blue-background' : indexOfElement !== addressSet.length - 1}">
                            <td>
                                {{address.address1}}
                            </td>
                            <td>
                                {{address.address2}}
                            </td>
                            <td>
                                {{address.city}}
                            </td>
                            <td>
                                {{address.state.label}}
                            </td>
                            <td>
                                {{address.country.label}}
                            </td>
                            <td>
                                {{address.postalCode}}
                            </td>
                            <td>
                                <button type="button" (click)="userAddress(address)" hvacButton="text">{{
                                    (indexOfElement === addressSet.length - 1 ? 'ADDRESS_LOOKUP.KEEP_EXISTING' :
                                    'ADDRESS_LOOKUP.USE_ADDRESS') | translate }}</button>
                            </td>

                        </tr>
                    </tbody>
                    <ng-template #loading>
                        <div class="hvac-address-corrector-loader">
                            <utc-loading-spinner></utc-loading-spinner>
                        </div>
                    </ng-template>
                </hvac-table>
            </div>
            <div class="hvac-address-lookup-modal-actions">
                <button buttonType="button" hvacButton="default" (click)="onCancel()">
                    {{'ADDRESS_LOOKUP.CANCEL' | translate }}
                </button>
            </div>

        </div>
    </ng-container>
</utc-modal>
